import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import User from "../../models/User";

export default function EditUserPage() {
    const { id } = useParams(); // الحصول على id المستخدم من الرابط
    const navigate = useNavigate();
    const { backEnd_request, governorates } = BackMethods();

    const [roles, setRoles] = useState([]);
    const [user, setUser] = useState(new User());
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    // 🔹 جلب بيانات المستخدم
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await backEnd_request.get(`/admin/UsersManagement/${id}`);
                setUser(res.data);
            } catch (error) {
                console.error("خطأ في جلب بيانات المستخدم:", error.response?.data || error);
                setFormError("حدث خطأ أثناء تحميل بيانات المستخدم");
            } finally {
                setIsLoading(false);
            }
        };

        const fetchRoles = async () => {
            try {
                const res = await backEnd_request.get("/admin/Roles");
                setRoles(res.data);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        };

        fetchRoles();
        fetchUser();
    }, [id]);

    // 🔁 تحديث البيانات عند التغيير
    const handleChange = (field, value) => {
        setUser((prev) => ({
            ...prev,
            [field]: field === "roleId" ? Number(value) || 0 : value,
        }));
    };

    // 🧾 تحقق بسيط
    const validate = () => {
        if (!user.firstName?.trim()) return "الرجاء إدخال الاسم الأول";
        if (!user.phoneNumber?.trim()) return "الرجاء إدخال رقم الهاتف";
        if (!user.roleId) return "الرجاء اختيار صلاحية المستخدم";
        return "";
    };

    // 🚀 إرسال البيانات للتعديل
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setSuccessMessage("");

        const error = validate();
        if (error) {
            setFormError(error);
            return;
        }

        setIsSubmitting(true);
        try {
            const payload = {
                firstName: user.firstName,
                fatherName: user.fatherName,
                lastName: user.lastName,
                phoneNumber: user.phoneNumber,
                governorate: user.governorate,
                city: user.city,
                sector: user.sector,
                roleId: user.roleId,
            };

            await backEnd_request.put(`/admin/UsersManagement/${id}`, payload);
            setSuccessMessage("تم تعديل بيانات المستخدم بنجاح!");
            setTimeout(() => navigate("/users-management"), 1500);
        } catch (err) {
            console.error(err);
            setFormError(err.response?.data?.message || "حدث خطأ أثناء تعديل المستخدم");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) {
        return (
            <div className="text-center text-light py-5">
                <h3>جاري تحميل بيانات المستخدم...</h3>
            </div>
        );
    }

    return (
        <div className="bg-dark min-vh-100 d-flex align-items-center py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h1 className="text-light fw-bold" style={{ fontSize: "2.3rem", letterSpacing: "1px" }}>
                        تعديل بيانات المستخدم
                    </h1>
                    <p className="text-light" style={{ fontSize: "1.1rem" }}>
                        يمكنك تعديل المعلومات أدناه ثم حفظ التغييرات
                    </p>
                </div>

                <div className="d-flex justify-content-center">
                    <div
                        className="card border-0 shadow-lg"
                        style={{ width: "100%", maxWidth: "800px", borderRadius: "20px" }}
                    >
                        <div
                            className="card-header text-center py-4"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderTopLeftRadius: "20px",
                                borderTopRightRadius: "20px",
                            }}
                        >
                            <h3 className="text-dark m-0 fw-bold">معلومات المستخدم</h3>
                        </div>

                        <div className="card-body bg-white p-5 rounded-bottom">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم الأول"
                                            value={user.firstName || ""}
                                            onChange={(e) => handleChange("firstName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="اسم الأب"
                                            value={user.fatherName || ""}
                                            onChange={(e) => handleChange("fatherName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الكنية"
                                            value={user.lastName || ""}
                                            onChange={(e) => handleChange("lastName", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="رقم الهاتف"
                                            value={user.phoneNumber || ""}
                                            onChange={(e) => handleChange("phoneNumber", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <select
                                            className="form-select p-3"
                                            value={user.governorate || ""}
                                            onChange={(e) => handleChange("governorate", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value="">اختر المحافظة</option>
                                            {governorates.map((g) => (
                                                <option key={g} value={g}>
                                                    {g}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="المدينة"
                                            value={user.city || ""}
                                            onChange={(e) => handleChange("city", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="القطاع"
                                            value={user.sector || ""}
                                            onChange={(e) => handleChange("sector", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <select
                                            className="form-select p-3"
                                            value={user.roleId || 0}
                                            onChange={(e) => handleChange("roleId", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value={0}>اختر الصلاحية</option>
                                            {roles.map((role) => (
                                                <option key={role.roleId} value={role.roleId}>
                                                    {role.displayName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* زر الحفظ */}
                                <div className="mt-4">
                                    <button
                                        type="submit"
                                        className={`btn w-100 py-3 fw-bold ${isSubmitting ? "btn-secondary" : "btn-dark text-light"
                                            }`}
                                        style={{ borderRadius: "12px", fontSize: "1.1rem" }}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "جارٍ الحفظ..." : "حفظ التغييرات"}
                                    </button>
                                </div>

                                {/* الرسائل */}
                                {formError && (
                                    <div className="text-danger text-center mt-3 fw-bold">
                                        {formError}
                                    </div>
                                )}
                                {successMessage && (
                                    <div className="text-success text-center mt-3 fw-bold">
                                        {successMessage}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
